import Vue from 'vue'
import VueRouter from 'vue-router'
import persistentData from '@/plugins/persistentData'
import Welcome from '@/views/Welcome/Main.vue'
import Login from '@/views/Login/Main.vue'
import LoginMail from '@/views/Login/LoginMail.vue'
import LoginIOS from '@/views/Login/IOS/Login.vue'
import UserActivateIOS from '@/views/Login/IOS/UserActivate.vue'
import LoginOnboarding from '@/views/Login/Onboarding.vue'
import RedirectLogin from '@/views/Login/RedirectLogin.vue'
import Register from '@/views/Register/Main.vue'
import RegisterSuccessful from '@/views/Register/Successful.vue'
import UserActivate from '@/views/Register/UserActivate.vue'
import RecoverPassword from '@/views/RecoverPassword/Main.vue'
import RecoveryCode from '@/views/RecoverPassword/RecoveryCode.vue'
import RecoverySuccessful from '@/views/RecoverPassword/Successful.vue'
import HomeGames from '@/views/Home/Games.vue'
import GameSelectTeam from '@/views/Game/SelectTeam.vue'
import GameSelectAvatar from '@/views/Game/Avatar.vue'
import GameTicketera from '@/views/Game/Ticketera.vue'
import GamePictureCapture from '@/views/Game/Picture/Capture.vue'
import GamePictureSuccessfull from '@/views/Game/Picture/Successfull.vue'
import Game from '@/views/Game/Game.vue'
import Profile from '@/views/Profile/Main.vue'
import Redirect from '@/views/Common/Redirect.vue'

Vue.use(VueRouter)

const guard = (to, from, next) => {
  if(persistentData.getData('token', false) !== null) {
    next()
  } else {
    next('/login')
  }
}

const checkWelcome = (to, from, next) => {
  if(window["cordova"] != undefined && window["device"] && window["device"].platform.toLowerCase() == 'ios'){
    next()
  }
  else {
    next('/login')
  }
}

const checkOnBoarding = (to, from, next) => {
  if(window["cordova"] != undefined && window["device"] && window["device"].platform.toLowerCase() == 'ios'){
    next('/home/games')
  }
  else {
    next()
  }
}

const routes = [
  {
    path: '/welcome',
    component: Welcome,
    beforeEnter : checkWelcome
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/login/mail',
    component: LoginMail
  },
  {
    path: '/login/ios',
    component: LoginIOS
  },
  {
    path: '/login/ios/activate',
    component: UserActivateIOS
  },
  {
    path: '/login/onboarding',
    component: LoginOnboarding,
    beforeEnter : checkOnBoarding
  },
  {
    path: '/redirect_login',
    component: RedirectLogin
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/register/activateUser/:email',
    component: UserActivate
  },
  {
    path: '/register/successful',
    component: RegisterSuccessful
  },
  {
    path: '/recoverPassword',
    component: RecoverPassword
  },
  {
    path: '/recoverPassword/code/:email',
    component: RecoveryCode
  },
  {
    path: '/recoverPassword/successful',
    component: RecoverySuccessful
  },
  {
    path: '/home/games',
    component: HomeGames,
    name: 'HomeGames',
    beforeEnter: guard
  },
  {
    path: '/game/:id/team',
    component: GameSelectTeam,
    beforeEnter: guard
  },
  {
    path: '/game/:id/:idTeam/avatar',
    component: GameSelectAvatar,
    beforeEnter: guard
  },
  {
    path: '/game/:id/ticketera',
    component: GameTicketera,
    beforeEnter: guard
  },
  {
    path: '/game/:idGame/:idTeam/picture',
    component: GamePictureCapture,
    name: 'ScreenGamePicture',
    beforeEnter: guard
  },
  {
    path: '/game/:idGame/:idTeam/picture/successfull',
    component: GamePictureSuccessfull,
    name: 'ScreenGamePictureSuccess',
    beforeEnter: guard
  },
  {
    path: '/game/:id',
    name: 'ScreenGame',
    component: Game,
    beforeEnter: guard
  },
  {
    path: '/profile',
    component: Profile,
    beforeEnter: guard
  },
  { 
    path: "*", 
    component: Redirect
  }
]

const router = new VueRouter({
  scrollBehavior: () => { 
    return { x: 0, y: 0 }
  },
  mode: (window["cordova"] == undefined ? 'history' : ''),
  base: process.env.BASE_URL,
  routes
})

export default router

